import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation("blog-isde");

  return (
    <section className="relative bg-brand-cream border-b border-brand-border overflow-hidden">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-3 mb-4 md:mb-5">
              <a
                href="/blog/"
                className="inline-flex items-center gap-1.5 font-geist text-sm text-brand-text/50 hover:text-brand-text transition-colors"
              >
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center text-sm"></i>
                Blog
              </a>
              <span className="text-brand-text/30">·</span>
              <span className="font-geist text-sm text-brand-text/50">
                {t("hero.readTime")}
              </span>
              <span className="text-brand-text/30">·</span>
              <span className="font-geist text-sm text-brand-text/50">
                {t("hero.updated")}
              </span>
            </div>
            <h1 className="font-geist font-bold text-2xl md:text-4xl text-brand-text mb-4 md:mb-6 leading-tight">
              {t("hero.h1")}
            </h1>
            <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed max-w-[640px]">
              {t("hero.subtitle")}
            </p>
          </div>
          <div className="w-full md:w-[380px] lg:w-[440px] flex-shrink-0">
            <div className="rounded-2xl overflow-hidden border border-brand-border">
              <img
                src={t("hero.image")}
                alt="ISDE-subsidie 2026 energiezuinige ramen"
                className="w-full h-48 md:h-64 object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}